import { createContext, useContext } from "react";

import type { NativeContextRNProps } from "../../props/NativeContextRNProps";

export interface ReportErrorContextValue {
  providerId: string;
  logError: (errorOrMessage: Error | string) => void;
  logHttpError: (
    url: string,
    message: string,
    statusCode: number,
    nativeContext: NativeContextRNProps | null | undefined,
  ) => void;
}

// Kept apart from ReportErrorProvider so low-level modules can read the
// provider without importing its rendering dependencies.
export const ReportErrorContext = createContext<ReportErrorContextValue | undefined>(undefined);

export function useOptionalReportError(): ReportErrorContextValue | undefined {
  return useContext(ReportErrorContext);
}

export function useReportError(): ReportErrorContextValue {
  const ctx = useOptionalReportError();
  if (!ctx) {
    throw new Error("useReportError must be used within a ReportErrorProvider");
  }
  return ctx;
}
